var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.342 6.055c0 1.135-.972 2.055-2.17 2.055C3.971 8.11 3 7.19 3 6.055S3.972 4 5.171 4c1.2 0 2.171.92 2.171 2.055M3.297 9.62h3.711V21H3.297zM12.984 9.62H9.272V21h3.711v-5.823c0-1.344.454-2.695 2.264-2.695 2.046 0 2.034 1.76 2.024 3.123-.012 1.782.018 3.6.018 5.395H21v-6.006c-.031-3.835-1.019-5.602-4.268-5.602-1.93 0-3.125.886-3.748 1.688z"
  })));
};
export default SvgLinkedin;